module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "klickbox-auth-loader"
  }, [_c('div', {
    staticClass: "klickart-loader-container"
  }, [_c('div', {
    staticClass: "klickart-loader"
  }), _vm._v(" "), _c('div', {
    staticClass: "klickbox-auth-label"
  }, [_vm._v("Aguarde...")])])])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-72913fac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Auth.vue
 ** module id = 857
 ** module chunks = 1
 **/